var _g, _circle, _circle2, _circle3, _circle4, _circle5, _g2, _circle6, _circle7, _circle8, _circle9, _circle0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 170,
    viewBox: "0 0 346 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.002 95.816C326.728 105.193 319.133 112.545 310.079 112.28C301.024 112.016 293.871 104.234 294.144 94.8576C294.418 85.4807 302.013 78.1291 311.067 78.3932C320.122 78.6573 327.275 86.4391 327.002 95.816Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.072 121.208C290.646 111.589 279.857 131.526 278.266 142.696C288.655 155.277 316.707 155.186 335.508 146.867C349.176 140.819 329.211 124.174 321.072 121.208Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 281.091,
    cy: 144.266,
    r: 1.9172,
    transform: "rotate(-2.77165 281.091 144.266)",
    fill: "#FB7C51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 340.241,
    cy: 141.527,
    r: 1.9172,
    transform: "rotate(1.67078 340.241 141.527)",
    fill: "#FB7C51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 310.169,
    cy: 112.265,
    r: 1.9172,
    transform: "rotate(1.67078 310.169 112.265)",
    fill: "#FB7C51"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 311.182,
    cy: 77.5289,
    r: 1.9172,
    transform: "rotate(1.67078 311.182 77.5289)",
    fill: "#FB7C51"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 308.993,
    cy: 152.562,
    r: 1.9172,
    transform: "rotate(1.67078 308.993 152.562)",
    fill: "#FB7C51"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6345 77.1709C52.0881 86.5407 45.0854 94.4586 36.0377 94.8966C26.99 95.3346 19.2552 88.1303 18.8016 78.7604C18.3479 69.3905 25.3507 61.4726 34.3984 61.0346C43.446 60.5966 51.1809 67.801 51.6345 77.1709Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6896 102.946C16.61 95.7133 7.39776 116.425 6.67657 127.685C18.0086 139.424 45.9691 137.16 64.0699 127.41C77.228 120.322 56.0334 105.273 47.6896 102.946Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 7.26658,
    cy: 126.82,
    r: 1.9172,
    transform: "rotate(-2.77165 7.26658 126.82)",
    fill: "#FB7C51"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 68.3748,
    cy: 121.719,
    r: 1.9172,
    transform: "rotate(-2.77165 68.3748 121.719)",
    fill: "#FB7C51"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 36.1264,
    cy: 94.873,
    r: 1.9172,
    transform: "rotate(-2.77165 36.1264 94.873)",
    fill: "#FB7C51"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 34.4461,
    cy: 60.1641,
    r: 1.9172,
    transform: "rotate(-2.77165 34.4461 60.1641)",
    fill: "#FB7C51"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.81,
    cx: 38.0758,
    cy: 135.141,
    r: 1.9172,
    transform: "rotate(-2.77165 38.0758 135.141)",
    fill: "#FB7C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.038 140.763L231.208 121.585C251.414 122.512 283.317 116.067 282.271 75.675C281.225 35.283 210.617 36.4005 192.586 64.5021C174.556 92.6037 192.187 107.789 199.218 116.872C206.249 125.955 231.444 139.905 238.679 143.249C244.466 145.924 243.996 142.706 243.038 140.763Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeDasharray: "3.75 3.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.248 136.629C217.656 137.725 218.931 138.952 220.29 140.108C222.032 141.589 223.756 142.353 225.625 143.535",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.26 119.383C193.897 121.252 195.284 123.253 197.172 124.89C198.563 126.096 200.19 127.054 201.535 128.296C202.343 129.041 203.637 129.675 204.69 129.808",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178 81.3652C178.123 84.448 178.246 87.5308 178.369 90.6135C178.54 94.8918 180.72 98.5071 183.189 101.909",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.145 42.8972C270.468 43.9079 272.782 45.2642 274.813 46.7819C275.952 47.633 276.536 48.9797 277.684 49.8897C280.83 52.3846 281.743 53.7348 281.827 57.7284",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8544 99.3171L73.8095 83.3381C64.6691 79.2109 48.1001 65.6882 54.9476 44.6145C63.507 18.2723 163.839 -14.5989 159.692 41.3317C156.375 86.0762 114.828 89.2995 94.4688 85.3181C89.6238 87.8375 78.1 94.3955 70.7649 100.473C63.4297 106.55 63.1016 102.234 63.8544 99.3171Z",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeDasharray: "3.75 3.75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 24.5293C163.435 29.9716 163.707 35.3309 163.973 40.8442",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8013 25.4939C68.2438 17.3695 80.0131 14.3804 91.1943 11.956",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.702 65.4522C157.849 68.5805 155.807 71.7587 153.759 74.7637C152.669 76.3641 151.184 77.5088 150.021 79.0316C148.072 81.5813 145.848 82.6925 142.824 83.7503C139.851 84.7899 136.214 86.2554 133.038 86.4091",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M114.737 92.0296C118.978 91.4014 123.651 90.9613 127.729 89.5797",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8961 103.962C81.6642 101.069 84.8144 99.4333 88.2091 97.4011C90.3522 96.1181 91.5518 94.9732 94.1149 94.8491",
    stroke: "#FB7C51",
    strokeWidth: 1.36297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1b42af6cc97f6d16108fdb77b97052eb.svg";
export { ForwardRef as ReactComponent };